import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Location")
const _hoisted_3 = { class: "grid gap-8 grid-cols-2 sm:grid-cols-2 md:grid-cols-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_5 = { class: "text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Size")
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Content Type")
const _hoisted_9 = { class: "text-gray-500" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Preview")
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 1,
  muted: "",
  class: "w-full shadow-xl rounded-lg",
  controls: ""
}
const _hoisted_14 = ["src", "type"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")

import { ref, toRefs, watchEffect } from 'vue';
import { getLinkPreview } from 'link-preview-js';
import { AccountPresenter, SHDWFileAccount } from '@/models';
import { toStorageSize } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: SHDWFileAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

const { name, size } = account.value.decodedData;
const location = `https://shdw-drive.genesysgo.net/${account.value.decodedData.storageAccount}/${account.value.decodedData.name}`;
const preview = ref('');
const content = ref('');

watchEffect(async () => {
  const { url, mediaType, contentType } = await getLinkPreview(location);
  if (mediaType === 'image' || mediaType === 'video') {
    preview.value = url;
  }
  if (contentType) {
    content.value = contentType;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_base_label, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        href: location,
        class: "group relative w-full flex justify-center py-2 px-4 border border-slate-200 text-gray-500 rounded-md text-black bg-gray-50 hover:bg-gray-100"
      }, _toDisplayString(location))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(name)), 1),
        _createVNode(_component_base_label, { class: "mt-4" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(toStorageSize)(_unref(size))), 1),
        (content.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_base_label, { class: "mt-4" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, _toDisplayString(content.value), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (preview.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_base_label, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            (content.value.startsWith('image'))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "w-full shadow-xl rounded-lg",
                  src: preview.value,
                  alt: _unref(name)
                }, null, 8, _hoisted_12))
              : (_openBlock(), _createElementBlock("video", _hoisted_13, [
                  _createElementVNode("source", {
                    src: preview.value,
                    type: content.value
                  }, null, 8, _hoisted_14),
                  _hoisted_15
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})